import React from "react";
import axios from 'axios';
// nodejs library that concatenates classes
import classNames from "classnames";
// react components used to create a google map
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";
import PinDrop from "@material-ui/icons/PinDrop";
import Phone from "@material-ui/icons/Phone";
import BusinessCenter from "@material-ui/icons/BusinessCenter";
// core components
import { Link } from "react-router-dom";
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import TextField from '@material-ui/core/TextField';
import Button from "components/CustomButtons/Button.jsx";
import Footer from "components/Footer/Footer.jsx";
import FooterLinks from "components/Footer/FooterLinks.jsx";

import contactUsStyle from "assets/jss/material-kit-pro-react/views/contactUsStyle.jsx";

const CustomSkinMap = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultZoom={16}
      defaultCenter={{ lat: 36.7376333, lng: -4.4347258 }}
      defaultOptions={{
        scrollwheel: false,
        zoomControl: true,
        styles: [
          {
            featureType: "water",
            stylers: [
              { saturation: 43 },
              { lightness: -11 },
              { hue: "#0088ff" }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              { hue: "#ff0000" },
              { saturation: -100 },
              { lightness: 99 }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#808080" }, { lightness: 54 }]
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [{ color: "#ece2d9" }]
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "#ccdca1" }]
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#767676" }]
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#ffffff" }]
          },
          { featureType: "poi", stylers: [{ visibility: "off" }] },
          {
            featureType: "landscape.natural",
            elementType: "geometry.fill",
            stylers: [{ visibility: "on" }, { color: "#b8cb93" }]
          },
          { featureType: "poi.park", stylers: [{ visibility: "on" }] },
          {
            featureType: "poi.sports_complex",
            stylers: [{ visibility: "on" }]
          },
          { featureType: "poi.medical", stylers: [{ visibility: "on" }] },
          {
            featureType: "poi.business",
            stylers: [{ visibility: "simplified" }]
          }
        ]
      }}
    >
      <Marker position={{ lat: 36.7351762, lng: -4.43397 }} />
    </GoogleMap>
  ))
);

class ContactUsPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isSent: false,

      formControls: {
        sender_name: '',
        sender_phone: '',
        sender_mail: '',
        message: '',
        subject: "I want to contact",
        website: "Kinoscorp EN - Contact",
        zone: ''

      }
    };
    this.onChange = this.onChange.bind(this);
  }

  //const [signupModal, setSignupModal] = React.useState(false);
  onChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        this.setState({
          formControls: {
              ...this.state.formControls,
              [name]: value
            }
        });

      }

  onSubmit = (e) => {
        e.preventDefault();
        this.setState({isSent: true}) ;
        // get our form data out of state
        const { formControls } = this.state;

        axios.post('https://api.kinosgroup.com/api/v1/en/messages/contact', { formControls })
          .then((result) => {
            //access the results here....
          });
      }


  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }
  render() {
    const { classes } = this.props;
    const { formControls } = this.state;

    return (
      <div>
        <Header
          brand="Kinos Corp"
          links={<HeaderLinks dropdownHoverColor="dark" />}
          fixed
          color="dark"
        />
        <div className={classes.bigMap}>
          <CustomSkinMap
            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyA42726T2lipqBYT7F5P98GFSH5rQ9MiSo"
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={
              <div
                style={{
                  height: `100%`,
                  borderRadius: "6px",
                  overflow: "hidden"
                }}
              />
            }
            mapElement={<div style={{ height: `100%` }} />}
          />
        </div>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.contactContent}>
            <div className={classes.container}>
              <h2 className={classes.title}>Send us a message</h2>
              <GridContainer>
                <GridItem md={6} sm={6}>
                  <p>
                    Contact with us for any question, we will answer as soon as we recibe your request.
                    <br />
                    <br />
                  </p>
                  <form>
                    <TextField
                        id="name"
                        label="Your name"
                        name="sender_name"
                        className={classes.formControl}
                        margin="normal"
                        fullWidth
                        value={formControls.sender_name}
                        onChange={this.onChange}

                      />
                      <TextField
                          id="mail"
                          label="Your email"
                          name="sender_mail"
                          className={classes.formControl}
                          margin="normal"
                          fullWidth
                          value={formControls.sender_mail}
                          onChange={this.onChange}

                        />
                        <TextField
                            id="phone"
                            label="Your phone"
                            name="sender_phone"
                            className={classes.formControl}
                            margin="normal"
                            fullWidth
                            value={formControls.sender_phone}
                            onChange={this.onChange}

                          />
                          <TextField
                              id="message"
                              label="Your message"
                              name="message"
                              className={classes.textArea}
                              margin="normal"
                              fullWidth
                              multiline
                              rows={5}
                              value={formControls.message}
                              onChange={this.onChange}
                            />
                    <div className={classes.textCenter}>
                      { this.state.isSent ? (
                          <Button color="" round>Message Sent</Button>
                            ) : (
                          <Button color="primary" round onClick={this.onSubmit}>Contact us</Button>
                         )}
                    </div>
                  </form>
                  <h5>
                  Please be aware that any personal data that you and others provide through this tool may be processed by Kinos. The protection of your personal data is very important to Kinos.
                  Kinos will process your personal data in compliance with applicable data protection laws. Your decision to provide your personal data to Kinos is voluntary.
                  However, given that certain functionalities of this tool require personal data to function, functionalities will not work if you decide not to provide your personal data.
                  Kinos invites you to carefully read its <Link to = "/ privacy"> privacy statement </Link>, which includes important information on why and how Kinos is processing your personal data.
                  </h5>

                </GridItem>
                <GridItem md={4} sm={4} className={classes.mlAuto}>
                  <InfoArea
                    className={classes.info}
                    title="Headquarters"
                    description={
                      <p>
                        Avd. Simón Bolivar, 17 Local 24<br /> CP 29011, Málaga,{" "}
                        <br /> Spain
                      </p>
                    }
                    icon={PinDrop}
                    iconColor="primary"
                  />

                  <InfoArea
                    className={classes.info}
                    title="Offices"
                    description={
                      <p>
                        C/ Alameda principal, 6, 3ª planta<br /> CP 29006, Málaga,{" "}
                        <br /> Spain
                      </p>
                    }
                    icon={PinDrop}
                    iconColor="primary"
                  />

                  <InfoArea
                    className={classes.info}
                    title="Call us"
                    description={
                      <p>
                        Grupo Kinos <br /> + 34 952 26 02 31 <br /> Mon - Fri,
                        9:00-21:00, Sat 8:00-14:00
                      </p>
                    }
                    icon={Phone}
                    iconColor="primary"
                  />
                  <InfoArea
                    className={classes.info}
                    title="Legal information"
                    description={
                      <p>
                        Kinos & Partners S.L. <br />  <br />  <br />
                      </p>
                    }
                    icon={BusinessCenter}
                    iconColor="primary"
                  />
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>
        <Footer>
          <FooterLinks/>
        </Footer>
      </div>
    );
  }
}

export default withStyles(contactUsStyle)(ContactUsPage);
